
import Vue from "vue";
import ChatInterface from "@/components/recruiter/assessments/ai-assessments/ChatInterface.vue";
import LeftPanel from "@/components/recruiter/assessments/ai-assessments/LeftPanel.vue";

export default Vue.extend({
  name: "AIAssessmentCreation",
  components: {
    ChatInterface,
    LeftPanel
  },
  methods: {
    onLeftPanelLoadingComplete() {
      // You can add any logic here when loading is complete
    }
  }
});
